"use client";

import { c as _c } from "react/compiler-runtime";
import NumberFlow from "@number-flow/react";
import { useEffect, useState } from "react";
import { getCommentCount } from "@/lib/server/comments";
const CommentCount = t0 => {
  const $ = _c(8);
  const {
    slug
  } = t0;
  const [count, setCount] = useState(null);
  const [error, setError] = useState(false);
  let t1;
  let t2;
  if ($[0] !== slug) {
    t1 = () => {
      getCommentCount(slug).then(result => {
        setCount(result);
      }).catch(err => {
        console.error("[comment-count] error:", err);
        setError(true);
      });
    };
    t2 = [slug];
    $[0] = slug;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (error) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span title="Error getting comments">?</span>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (count === null) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="motion-safe:animate-pulse">0</span>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t3 = count === null ? "motion-safe:animate-pulse" : undefined;
  let t4;
  if ($[5] !== count || $[6] !== t3) {
    t4 = <NumberFlow className={t3} locales={process.env.NEXT_PUBLIC_SITE_LOCALE} value={count} />;
    $[5] = count;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export { CommentCount };